import loadable from '@loadable/component';
import {
  PAYMENT_WIDGET_CARD,
  DATE_PICKER_CARD,
  REFUND_TRACKER_CARD,
  REWARDS_TRACKER_CARD,
  FLIGHTS_CHANGE,
  FLIGHTS_CREDIT_BOOKING,
  DATA_COLLECTOR,
  AIR_FARE_RULES,
  PNR_DETAILS,
  TERMS_AND_CONDITIONS,
  PENALTY,
  FLIGHT_REFUND,
  FARE_RULES,
  SINGLE_DATE_PICKER_CARD,
  FLIGHT_SCHEDULE_CHANGE,
  DECLARATIVE_CARD,
} from '../../api/common/constants';

export const LoadablePayment = loadable(() =>
  import(/* webpackChunkName: "Payment" */ './Payment/index'),
);

export const LoadableDatePicker = loadable(() =>
  import(/* webpackChunkName: "DatePicker" */ './DatePicker/index'),
);

export const LoadableSingleDatePicker = loadable(() =>
  import(/* webpackChunkName: "SingleDatePicker" */ './SingleDatePicker/index'),
);

export const LoadableRefundTracker = loadable(() =>
  import(/* webpackChunkName: "refundtracker" */ './RefundTracker/index'),
);

export const LoadableRewardsTracker = loadable(() =>
  import(/* webpackChunkName: "rewardstracker" */ './RewardsTracker/index'),
);

export const LoadableFlightsChange = loadable(() =>
  import(/* webpackChunkName: "flightschange" */ './FlightsChange/index'),
);

export const LoadableFlightsScheduleChange = loadable(() =>
  import(
    /* webpackChunkName: "FlightsScheduleChange" */ './FlightsScheduleChange/index'
  ),
);

export const LoadableDataCollector = loadable(() =>
  import(/* webpackChunkName: "datacollector" */ './DataCollector/index'),
);

export const LoadableAirFareRules = loadable(() =>
  import(/* webpackChunkName: "airfarerules" */ './AirFareRules/index'),
);

export const LoadableTermsAndConditions = loadable(() =>
  import(
    /* webpackChunkName: "termsandconditions" */ './TermsAndConditions/index'
  ),
);

export const LoadablePnrDetails = loadable(() =>
  import(/* webpackChunkName: "pnrdetails" */ './PnrDetails/index'),
);

export const LoadablePenalty = loadable(() =>
  import(/* webpackChunkName: "penalty" */ './Penalty/index'),
);

export const LoadableFlightRefund = loadable(() =>
  import(/* webpackChunkName: "flightrefund" */ './FlightRefund/index'),
);

export const LoadableFareRules = loadable(() =>
  import(/* webpackChunkName: "farerules" */ './FareRules/index'),
);

export const LoadableDeclarativeCard = loadable(() =>
  import(/* webpackChunkName: "declarativeCard" */ './DeclarativeCard/index'),
);

const cardMapper = {
  [PAYMENT_WIDGET_CARD]: LoadablePayment,
  [DATE_PICKER_CARD]: LoadableDatePicker,
  [SINGLE_DATE_PICKER_CARD]: LoadableSingleDatePicker,
  [REFUND_TRACKER_CARD]: LoadableRefundTracker,
  [REWARDS_TRACKER_CARD]: LoadableRewardsTracker,
  [FLIGHTS_CHANGE]: LoadableFlightsChange,
  [FLIGHT_SCHEDULE_CHANGE]: LoadableFlightsScheduleChange,
  [FLIGHTS_CREDIT_BOOKING]: LoadableFlightsChange,
  [DATA_COLLECTOR]: LoadableDataCollector,
  [AIR_FARE_RULES]: LoadableAirFareRules,
  [FARE_RULES]: LoadableFareRules,
  [FLIGHT_REFUND]: LoadableFlightRefund,
  [PENALTY]: LoadablePenalty,
  [TERMS_AND_CONDITIONS]: LoadableTermsAndConditions,
  [PNR_DETAILS]: LoadablePnrDetails,
  [DECLARATIVE_CARD]: LoadableDeclarativeCard,
};

export default cardMapper;
